module.exports = __webpack_public_path__ + "img/img-1.0b11bf35.jpg";